<template>
  <div v-if="order[0]">
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4 class="flex" v-if="selectedCustomer">
            <div style="transform: translateX(0.4em);">
              <vs-avatar :src="selectedCustomer.customer.image" size="40px" class="ml-" style="transform: translateY(-0.1em); cursor: default;"/> 
            </div>
        </h4>
        <vs-icon icon="shopping_cart" size="1.1em"></vs-icon>
        <div v-if="selectedCustomer">
          <p class="flex" style="width: 15em;"><b>{{ selectedCustomer.customer.name }}</b></p>
          <p class="flex" style="width: 15em;">Pedido feito via Catálogo</p>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        />
      </div>
      <div class="flex" style="margin-top: 1em;">
        <b style="margin-left: 3.5em;">ITEM</b>
        <div>
          <b style="margin-left: 14.5em;">PREÇO</b>
        </div>
      </div>
      <vs-divider class="mb-0"/>

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div v-for="(tr, index) in order" :key="index" class="p-6 flex w-full">
          <div class="d-flex flex-row items-center justify-around">
            <img v-if="tr.thumbnailUrl" :src="tr.thumbnailUrl" style="width: 60px !important; height: 55px !important; border-top-left-radius: 5px; border-bottom-left-radius: 5px; border-top-right-radius: 5px; border-bottom-right-radius: 5px; margin-left: 1em;">
            <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 60px !important; height: 55px !important; border-top-left-radius: 5px; border-bottom-left-radius: 5px; border-top-right-radius: 5px; border-bottom-right-radius: 5px; margin-left: 1em;">
          </div>
          <vs-alert
            active="true"
            class="no-message-alert rounded-alert"
            color=""
            style="border-radius: 0 0 5px 0;"
          >
              <vx-tooltip v-if="tr.name.length > 15" :text="tr.name">
                <b style="color: #343a40;">{{ lengthText(tr.name) }}</b>
              </vx-tooltip>
              <b v-else style="color: #343a40;">{{tr.name}}</b>
              <div class="flex">
                <div>
                  <p style="width: 6em; color: #343a40;">Qtde: {{ tr.quantity }}</p>
                </div>
                <div style="transform: translateY(-0.8em);">
                  <b style="margin-left: 6em; color: #343a40;">{{returnCash(tr.price)}}</b>
                </div>
              </div>
          </vs-alert>
        </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <div class="flex" style="margin-bottom: 2em;" @mouseover="mouseOver">
          <b>Total: </b>
          <div>
              <b style="margin-left: 16.5em;">{{returnCash(amountCash)}}</b>
            </div>
        </div>
        <vs-button @mouseover="mouseOverAccept" class="w-full" color="success" @click="submitAccepted(order[0].customer_chat_id)" :disabled="order[0].status">
          Aceitar Pedido
        </vs-button>
        <div class="centerx labelx">
          <vs-input
            v-if="activeAccept"
            class="mt-1" 
            style="width: 25.6em" 
            placeholder="" 
            v-model="messageAccepted"
          />
        </div>
        <vs-button @mouseover="mouseOverReject" class="w-full mt-2" type="border" color="danger" @click="submitRejected(order[0].customer_chat_id)" :disabled="order[0].status">
          Recusar Pedido
        </vs-button>
        <div class="centerx labelx">
          <vs-input 
            v-if="activeReject"
            class="mt-1" 
            style="width: 25.6em" 
            placeholder="" 
            v-model="messageRejected"
          />
        </div>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import { hasPermission } from '@/utils'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import catalog from '@/http/requests/catalog/index.js'

export default {
  name: 'get-order-by-msg',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    order: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default: () => {
        return {
          currency: "BRL",
          customer_chat_id: null,
          instance_id: null,
          name: false,
          price: false,
          product_id: '',
          quantity: '',
          thumbnail: '',
          thumbnailUrl: ''
        }
      }
    },
    chat: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default: () => {
        return {
          ack: null,
          caption: null,
          chat_ticket_id: null,
          customerChatStatus: null,
          customer_id: null,
          document_mimetype: null,
          document_name: null,
          hash: null,
          id: null,
          instance_id: null,
          is_bot_message: null,
          message: '',
          message_buttons: null,
          message_footer: null,
          message_header: null,
          off_customer_chat: null,
          recovered: null,
          sent_at: null,
          tag_type: null,
          type: null,
          user_sending_id: null,
          user_sending_img: null,
          whatsapp_deleted_at: null,
        }
      }
    }
  },
  data() {
    return {
      addGroupPopupActive: false,
      amountCash: 0,
      selectedCustomer: null,
      activeAccept: false,
      activeReject: false,
      messageAccepted: 'A empresa aceitou o pedido.',
      messageRejected: 'A empresa recusou o pedido.',
      settings: { maxScrollbarLength: 60 }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
  },
  methods: {
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`)
    },
    mouseOver() {
      this.activeAccept = false;
      this.activeReject = false;
    },
    mouseOverAccept() {
      this.activeAccept = true;
      this.activeReject = false;
    },
    mouseOverReject() {
      this.activeReject = true;
      this.activeAccept = false;
    },
    returnCash(value) {
      return (value / 1000).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    submitAccepted(customerChatId) {
      catalog.updateStatusOrderByMsg(customerChatId, true)
      this.isSidebarActiveLocal = false;
      this.$events.fire('ReplyOrder', true, this.messageAccepted ? this.messageAccepted : 'A empresa aceitou o pedido.')
      this.messageAccepted = 'A empresa aceitou o pedido.';
    },
    submitRejected(customerChatId) {
      catalog.updateStatusOrderByMsg(customerChatId, true)
      this.isSidebarActiveLocal = false;
      this.$events.fire('ReplyOrder', false, this.messageRejected ? this.messageRejected : 'A empresa recusou o pedido.')
      this.messageRejected = 'A empresa recusou o pedido.';
    },
    lengthText(text, where) {
      if (text.length <= 15) {
        return text;
      } else {
        return text.slice(0, 15) + "...";
      }
    },
  },
  created() {
    this.$events.off('selectContact')
    this.$events.on('selectContact', (data, amountCash) => {
      this.amountCash = amountCash;
      this.selectedCustomer = data;
    })
  },
  watch: {},
  async mounted() {},
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px - 80px - 80px);
}
</style>
